export default "__VITE_ASSET__B5l6PB8c__"